import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { DailyLegLoadGraphPage } from './daily-leg-load-graph';
import { SharedModule } from '../../shared/shared.module';
import { ChartsModule } from 'ng2-charts-x';
import { DirectivesModule } from '../../../directives/directives.module';

@NgModule({
  declarations: [
    DailyLegLoadGraphPage,
  ],
  imports: [
    DirectivesModule,
    IonicPageModule.forChild(DailyLegLoadGraphPage),
    SharedModule,
    ChartsModule,
  ],
})
export class DailyLegLoadGraphPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/daily-leg-loads/daily-leg-load-graph/daily-leg-load-graph.module.ts